export default "__VITE_ASSET__EYYjdTl4__"